<app-kontable
  id="dt_dsnoperationmail"
  title="{{ 'dsnOperationMailList.sectionTitle' | translate }}"
  [columns]="['id', 'divSalesName', 'paramCode', 'email', 'clusterDescription',  'serviceName']"
  [titles]="['ID', 'dsnOperationMailList.salesNetworkName', 'permissionForm.operationName', 'userForm.email', 'dsnOperationMailList.clusterDescription', 'dsnOperationMailList.serviceName' ]"
  [source]="dsnOperationMails"
  [showInfoButton]="false"
  [showRecoverButton]="true"
  [showDetailsButton]="false"
  [showAddButton]="true"
  [showGlobalFilter]="false"
  (onAdd)="showAddOrEditDialog($event)"
  (onEdit)="showAddOrEditDialog($event)"
  (onRemove)="delete($event)"
  (onRecover)="recoverDsnOperationMail($event)">
</app-kontable>

<!-- <ng-template #customRowCommands data-testid="customRowCommands" let-row>
        <p-button pTooltip="{{ 'common.duplicate' | translate }}" label="" icon="fa fas fa-files-o" styleClass="ui-button-info" (onClick)="duplicateDsnOperationMail(row)"></p-button>
</ng-template> -->

<p-dialog
        *ngIf="showDetail"
        [(visible)]="showDetail"
        [modal]="true"
        header="{{modalTitle}}"
        [minWidth]="500"
        [draggable]="false"
        [resizable]="false"
        (onHide)="closeDialog()">
    <app-dsn-operation-mail-form
            (onAddElement)="dsnOperationMailAdded($event)"
            (onUpdateElement)="dsnOperationMailUpdated($event)"
            [dialogBoxDsnOperationMail]="srvDsnOperationMail.dsnOperationMailEditing"
    ></app-dsn-operation-mail-form>
</p-dialog>



// WEBPACK FOOTER //
// ./src/app/views/administration/dsn-operation-mail/dsn-operation-mail.component.html